import { useGenerateOgpImage } from "@roman/shared/hooks/PredictionMarket/useGenerateOgpImage";
import type { PredictionMarketWithProbability } from "@roman/shared/types/PredictionMarket";
import { Share2Icon } from "lucide-react";
import { handleShare } from "./handleShare";

interface EntryShareButtonProps {
  market: PredictionMarketWithProbability;
  className?: string;
}

export const EntryShareButton: React.FC<EntryShareButtonProps> = ({ market, className }) => {
  // const [isShareModalOpen, setIsShareModalOpen] = useState(false);
  const { generateOgpImage } = useGenerateOgpImage();

  const handleShareClick = async (e: React.MouseEvent) => {
    e.stopPropagation();
    handleShare(market);
    await generateOgpImage({ marketId: market.id });
  };

  return (
    <Share2Icon className={`text-dark-gray w-5 h-5 cursor-pointer ${className || ""}`} onClick={handleShareClick} />
  );
};
